<div class="container">
  <h2>Booth Owner Change Requests</h2>

  <div class="controls">
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="statusFilter" (selectionChange)="refresh()">
        <mat-option value="PENDING">Pending</mat-option>
        <mat-option value="ACCEPTED">Accepted</mat-option>
        <mat-option value="DENIED">Denied</mat-option>
        <mat-option value="ALL">All</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="refresh()">Refresh</button>
  </div>

  <table mat-table [dataSource]="requests" class="mat-elevation-z2 fullwidth">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let r">{{r.id}}</td>
    </ng-container>

    <ng-container matColumnDef="booth">
      <th mat-header-cell *matHeaderCellDef>Booth</th>
      <td mat-cell *matCellDef="let r">#{{r.booth_id}}</td>
    </ng-container>

    <ng-container matColumnDef="requestedBy">
      <th mat-header-cell *matHeaderCellDef>Requested By</th>
      <td mat-cell *matCellDef="let r">{{r.requested_by_uuid}}</td>
    </ng-container>

    <ng-container matColumnDef="newOwner">
      <th mat-header-cell *matHeaderCellDef>New Owner</th>
      <td mat-cell *matCellDef="let r">{{r.new_owner_username}} ({{r.new_owner_uuid}})</td>
    </ng-container>

    <ng-container matColumnDef="discord">
      <th mat-header-cell *matHeaderCellDef>Discord</th>
      <td mat-cell *matCellDef="let r">{{r.new_owner_discord_id}}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let r">{{r.email}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let r">{{r.status}}</td>
    </ng-container>

    <ng-container matColumnDef="reason">
      <th mat-header-cell *matHeaderCellDef>Reason</th>
      <td mat-cell *matCellDef="let r">
        <ng-container *ngIf="r.status==='PENDING'; else reasonText">
          <mat-form-field appearance="outline" class="reason-field">
            <mat-label>Deny reason</mat-label>
            <input matInput [(ngModel)]="denyReason[r.id]" placeholder="Enter reason"/>
          </mat-form-field>
        </ng-container>
        <ng-template #reasonText>{{r.reason || '-'}}</ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let r">
        <button mat-stroked-button color="primary" (click)="accept(r)" [disabled]="r.status!=='PENDING'">Accept</button>
        <button mat-stroked-button color="warn" (click)="deny(r)" [disabled]="r.status!=='PENDING'">Deny</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-progress-spinner *ngIf="loading" class="spinner" diameter="36" mode="indeterminate"></mat-progress-spinner>
</div>
